import { StatusBadge } from '@/components/common/StatusBadge';
import type { StatusColorTone } from '@/styles/statusColors';
import { SURVEY_STATUS_LABELS } from '../constants/survey.constants';
import type { SurveyStatus } from '../types/survey.types';

interface SurveyStatusBadgeProps {
  status: SurveyStatus;
}

const SURVEY_STATUS_TONE: Record<SurveyStatus, StatusColorTone> = {
  draft: 'neutral',
  active: 'success',
  expired: 'neutral',
};

export function SurveyStatusBadge({ status }: SurveyStatusBadgeProps) {
  return (
    <StatusBadge tone={SURVEY_STATUS_TONE[status]}>{SURVEY_STATUS_LABELS[status]}</StatusBadge>
  );
}
